import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Box, 
  Paper, 
  Alert 
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/');
    } catch (error) {
      setError('Failed to log in: ' + error.message);
    }

    setLoading(false);
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
          <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
            <Logo height={100} />
          </Box>
          <Typography variant="h6" component="h6" gutterBottom align="center">
            Log In to Vital Reflection
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              Log In
            </Button>
            <Box sx={{ textAlign: 'center',  mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <Link to="/password-reset" style={{ color: '#4dccc3' }}>Forgot Password?</Link>
              </Typography>
              <Typography variant="body2">
                Need an account? <Link to="/signup" style={{ color: '#4dccc3' }}>Sign Up</Link>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Button
          variant="outlined"
          sx={{
          backgroundColor: '#4dccc3',
          color: '#ffffff',
          fontWeight: 'bold',
          border: 'none',
          '&:hover': {
            backgroundColor: '#3ba99c',
          },
          }}
          onClick={() => navigate('/marketing')}
        >
          Learn More about Vital Reflection
        </Button>
      </Box>
    </Container>
  );
}

export default Login;
